var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, runInAction } from "mobx";
export class GlobalAdminSkillEvalManager {
    constructor(service) {
        this.service = service;
        this.runs = [];
        this.selectedRun = null;
        this.loadingRuns = false;
        this.loadingMore = false;
        this.hasMoreRuns = false;
        this.pageSize = 50;
        this.loadContext = null;
        this.loadingDetail = false;
        this.submittingReview = false;
        this.allPartners = [];
    }
    async loadAllPartners() {
        try {
            const partners = await this.service.listAllAiPartners();
            runInAction(() => (this.allPartners = partners));
        }
        catch {
            runInAction(() => (this.allPartners = []));
        }
    }
    async loadRuns(patientId) {
        this.loadContext = { type: "patient", patientId };
        await this.loadFirstPage();
    }
    async loadRunsByProject(projectId) {
        this.loadContext = { type: "project", projectId };
        await this.loadFirstPage();
    }
    fetchRunsPage(offset) {
        const ctx = this.loadContext;
        if (!ctx)
            return Promise.resolve([]);
        return ctx.type === "patient"
            ? this.service.listRuns(ctx.patientId, this.pageSize, offset)
            : this.service.listRunsByProject(ctx.projectId, this.pageSize, offset);
    }
    async loadFirstPage() {
        runInAction(() => {
            this.loadingRuns = true;
            this.selectedRun = null;
            this.loadingDetail = false;
        });
        try {
            const page = await this.fetchRunsPage(0);
            runInAction(() => {
                this.runs = page;
                this.hasMoreRuns = page.length === this.pageSize;
            });
        }
        finally {
            runInAction(() => (this.loadingRuns = false));
        }
    }
    async loadMoreRuns() {
        if (!this.loadContext || this.loadingMore || !this.hasMoreRuns)
            return;
        runInAction(() => (this.loadingMore = true));
        try {
            const page = await this.fetchRunsPage(this.runs.length);
            runInAction(() => {
                this.runs = [...this.runs, ...page];
                this.hasMoreRuns = page.length === this.pageSize;
            });
        }
        finally {
            runInAction(() => (this.loadingMore = false));
        }
    }
    async selectRun(runId) {
        runInAction(() => {
            this.loadingDetail = true;
            this.selectedRun = null;
        });
        try {
            const run = await this.service.getRun(runId);
            if (!run)
                throw new Error("This run no longer exists — it may have been deleted.");
            runInAction(() => (this.selectedRun = run));
        }
        finally {
            runInAction(() => (this.loadingDetail = false));
        }
    }
    async submitReview(runId, req) {
        runInAction(() => (this.submittingReview = true));
        try {
            await this.service.submitReview(runId, req);
            await this.selectRun(runId);
            const detail = this.selectedRun;
            if (detail && detail.id === runId) {
                runInAction(() => {
                    this.runs = this.runs.map((r) => r.id === runId ? { ...r, reviewCount: detail.reviewCount, latestVerdict: detail.latestVerdict } : r);
                });
            }
        }
        finally {
            runInAction(() => (this.submittingReview = false));
        }
    }
}
__decorate([
    observable
], GlobalAdminSkillEvalManager.prototype, "runs", void 0);
__decorate([
    observable
], GlobalAdminSkillEvalManager.prototype, "selectedRun", void 0);
__decorate([
    observable
], GlobalAdminSkillEvalManager.prototype, "loadingRuns", void 0);
__decorate([
    observable
], GlobalAdminSkillEvalManager.prototype, "loadingMore", void 0);
__decorate([
    observable
], GlobalAdminSkillEvalManager.prototype, "hasMoreRuns", void 0);
__decorate([
    observable
], GlobalAdminSkillEvalManager.prototype, "loadingDetail", void 0);
__decorate([
    observable
], GlobalAdminSkillEvalManager.prototype, "submittingReview", void 0);
__decorate([
    observable
], GlobalAdminSkillEvalManager.prototype, "allPartners", void 0);
